{
    "(save {highestYearlyDiscount}%)": "(уштедите {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} дана бесплатно",
    "{amount} off": "{amount} попуста",
    "{amount} off for first {number} months.": "{amount} попуста за првих {number} месеци.",
    "{amount} off for first {period}.": "{amount} попуста за први {period}.",
    "{amount} off forever.": "{amount} попуста заувек.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% попуста",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} више неће добијати {newsletterName} билтен.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} више неће добијати email-ове када неко одговори на Ваше коментаре.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} више неће добијати овај билтен.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} дана бесплатно",
    "{years} years": "",
    "+1 (123) 456-7890": "+381 60 123-456",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Налог",
    "Account details updated successfully": "Детаљи налога су успешно ажурирани",
    "Account settings": "Подешавања налога",
    "Add a personal note": "Додајте личну напомену",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Након што истекне бесплатан пробни период, биће Вам наплаћена редовна цена за ниво који сте одабрали. Увек можете отказати пре тог рока.",
    "Already a member?": "Већ сте члан?",
    "An error occurred": "Дошло је до грешке",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Дошло је до неочекиване грешке. Покушајте поново или <a>контактирајте подршку</a> ако грешка потраје.",
    "Back": "Назад",
    "Back to Log in": "Назад на пријаву",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Црни петак",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Откажите у било ком тренутку.",
    "Cancel subscription": "Откажите претплату",
    "Canceled": "",
    "Cancellation reason": "Разлог отказивања",
    "Change": "Промените",
    "Change plan": "Промените план",
    "Check spam & promotions folders": "Проверите фасцикле за нежељену пошту и промоције",
    "Check with your mail provider": "Проверите са Вашим mail провајдером",
    "Check your inbox to verify email update": "Проверите Ваш inbox да верификујете промену email-а",
    "Choose": "Изаберите",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Изаберите други план",
    "Choose a plan": "Изаберите план",
    "Choose a tier": "",
    "Choose your newsletters": "Изаберите своје билтене",
    "Click here to retry": "Кликните овде да покушате поново",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Затворите",
    "Code": "Код",
    "Comment preferences updated.": "Преференце коментара ажуриране.",
    "Comments": "Коментари",
    "Complimentary": "Бесплатно",
    "Confirm": "Потврдите",
    "Confirm cancellation": "Потврдите отказивање",
    "Confirm subscription": "Потврдите претплату",
    "Contact support": "Контактирајте подршку",
    "Continue": "Наставите",
    "Continue subscription": "Наставите претплату",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "Није могуће креирати сесију Stripe портала наплате",
    "Could not create Stripe checkout session": "Није могуће креирати сесију плаћања помоћу Stripe-а",
    "Could not sign in. Login link expired.": "Није могуће пријавити се. Линк за пријаву је истекао.",
    "Could not update email! Invalid link.": "Није могуће ажурирати email! Невалидан линк.",
    "Create a new contact": "Направите нови контакт",
    "Current plan": "Тренутни план",
    "Delete account": "Обришите налог",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Нисте желели ово да урадите? Управљајте својим преференцама <button>овде</button>.",
    "Don't have an account?": "Немате налог?",
    "Edit": "Уредите",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Email билтен",
    "Email newsletter settings updated": "Подешавања email билтена ажурирана.",
    "Email preferences": "Преференце за email",
    "Email preferences updated.": "Преференце за email ажуриране.",
    "Emails": "Email-ови",
    "Emails disabled": "Email-ови онемогућени",
    "Ends {offerEndDate}": "Завршава се {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "Унесите код изнад",
    "Enter the recipient's email address": "",
    "Enter your email address": "Унесите Вашу email адресу",
    "Enter your name": "Унесите Ваше име",
    "Error": "Грешка",
    "Expires {expiryDate}": "Истиче {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Неуспешно отказивање претплате, покушајте поново",
    "Failed to log in, please try again": "Неуспешна пријава, покушајте поново",
    "Failed to log out, please try again": "Неуспешно одјављивање, покушајте поново",
    "Failed to open billing portal, please try again": "Неуспешно отварање портала наплате, покушајте поново",
    "Failed to process checkout, please try again": "Неуспешна обрада плаћања, покушајте поново",
    "Failed to send magic link email": "Неуспешно слање email-а са магичним линком",
    "Failed to send verification email": "Неуспешно слање верификационог email-а",
    "Failed to sign up, please try again": "Неуспешна регистрација, покушајте поново",
    "Failed to update account data": "Неуспешно ажурирање података налога",
    "Failed to update account details": "Неуспешно ажурирање детаља налога",
    "Failed to update billing information, please try again": "Неуспешно ажурирање информација о наплати, покушајте поново",
    "Failed to update newsletter settings": "Неуспешно ажурирање подешавања билтена",
    "Failed to update subscription, please try again": "Неуспешно ажурирање претплате, покушајте поново",
    "Failed to verify code, please try again": "Неуспешна верификација кода, покушајте поново",
    "For a friend or colleague": "",
    "Forever": "Заувек",
    "Free Trial – Ends {trialEnd}": "Бесплатан пробни период – Завршава се {trialEnd}",
    "From": "",
    "Get help": "Затражите помоћ",
    "Get in touch for help": "Контактирајте нас за помоћ",
    "Get notified when someone replies to your comment": "Примите обавештење када неко одговори на Ваш коментар",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Дајте повратну информацију о овој објави",
    "Help! I'm not receiving emails": "Помоћ! Не примам email-ове",
    "Here are a few other sites you may enjoy.": "Ево неколико других сајтова који Вам могу бити занимљиви.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ако је билтен означен као нежељена пошта, email-ови су аутоматски онемогућени за ту адресу како бисте престали примати нежељене поруке.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ако је жалба за нежељену пошту била случајна или желите поново да примате email-ове, можете се поново претплатити кликом на дугме на претходном екрану.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ако сада откажете претплату имаћете приступ до {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ако имате корпоративни или владин email налог, обратите се свом ИТ одељењу и замолите их да дозволе примање email-ова од {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Линк за пријаву је послат у Ваш inbox. Ако не стигне у року од 3 минута, проверите фасциклу за нежељену пошту.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Email је послат на {submittedEmailOrInbox}. Кликните на линк унутар њега или унесите код испод.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ако желите поново да примате email-ове, најбољи наредни кораци су да проверите адресу email-а у датотеци за било какве проблеме и потом кликнете на поновну претплату на претходном екрану.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ако не примате email билтен на који сте се претплатили, ево неколико ствари које треба проверити.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ако сте завршили све ове кораке и још увек не примате email-ове, можете затражити помоћ контактирањем {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "У случају да дође до трајног квара приликом слања билтена, email-ови ће бити онемогућени на налогу.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Додајте {senderEmail} у своју листу контаката у email клијенту. Ово сигнализира Вашем mail провајдеру да треба веровати порукама послатим са ове адресе.",
    "Invalid email address": "Невалидна email адреса",
    "Invalid verification code": "Невалидан верификациони код",
    "Jamie Larson": "Пера Перић",
    "jamie@example.com": "pera@example.com",
    "Less like this": "Мање налик на ово",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Уверите се да email-ови случајно не завршавају у фасциклама за нежељену пошту или промоције у Вашем inbox-у. Ако јесу, кликните на „Означи као да није нежељено“ и/или „Премести у inbox“.",
    "Manage": "Управљајте",
    "Maybe later": "Можда касније",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Чланства са овог email домена су тренутно ограничена.",
    "Memberships unavailable, contact the owner for access.": "Чланства нису доступна, контактирајте власника ради приступа.",
    "month": "месец",
    "Monthly": "Месечно",
    "More like this": "Више налик на ово",
    "More options": "",
    "Name": "Име",
    "Need more help? Contact support": "Треба Вам више помоћи? Контактирајте подршку",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Билтени могу бити онемогућени на Вашем налогу из два разлога: претходни email је означен као нежељена пошта или је покушај слања email-а резултирао трајним неуспехом (одбијено).",
    "No member exists with this e-mail address.": "Не постоји члан са овом email адресом.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Не примате email-ове?",
    "Now": "",
    "Now check your email!": "Сада проверите свој email!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Када се поново претплатите, ако и даље не видите email-ове у свом inbox-у, проверите фасциклу за нежељену пошту. Неки inbox провајдери чувају записе о претходним жалбама на нежељену пошту и наставиће да означавају email-ове. Ако се то деси, означите најновији билтен као 'Није нежељено' да га преместите назад у свој inbox.",
    "Open AOL Mail": "Отворите AOL Mail",
    "Open email": "Отворите email",
    "Open Feedbin": "",
    "Open Gmail": "Отворите Gmail",
    "Open Hey": "Отворите Hey",
    "Open iCloud Mail": "Отворите iCloud Mail",
    "Open Mail.ru": "Отворите Mail.ru",
    "Open Outlook": "Отворите Outlook",
    "Open Proton Mail": "Отворите Proton Mail",
    "Open Yahoo Mail": "Отворите Yahoo Mail",
    "Optional message": "",
    "Permanent failure (bounce)": "Трајни неуспех (одбијено)",
    "Phone number": "Број телефона",
    "Plan": "План",
    "Plan checkout was cancelled.": "Плаћање плана је отказано.",
    "Plan upgrade was cancelled.": "Надоградња плана је отказана.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Контактирајте {supportAddress} да подесите Вашу бесплатну претплату.",
    "Please enter {fieldName}": "Молимо Вас унесите {fieldName}",
    "Please fill in required fields": "Молимо Вас попуните обавезна поља",
    "Podcasts": "",
    "Re-enable emails": "Поново омогућите email-ове",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Препоруке",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Обнавља се по цени од {price}.",
    "Resume subscription": "",
    "Retry": "Покушајте поново",
    "Save": "Сачувајте",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Слање линка за пријаву...",
    "Sending...": "Слање...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Прикажите све",
    "Sign in": "Пријавите се",
    "Sign out": "Одјавите се",
    "Sign up": "Региструјте се",
    "Signup error: Invalid link": "Грешка при регистрацији: Невалидан линк",
    "Signups from this email domain are currently restricted.": "Регистрације са овог email домена су тренутно ограничене.",
    "Something went wrong, please try again later.": "Нешто је пошло наопако, молимо Вас покушајте касније.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Извините, али препоруке тренутно нису доступне.",
    "Sorry, that didn’t work.": "Извините, то није успело.",
    "Spam complaints": "Жалбе на нежељену пошту",
    "Start {amount}-day free trial": "Започните {amount}-дневни бесплатни пробни период",
    "Starting {startDate}": "Почиње {startDate}",
    "Starting today": "Почиње данас",
    "Submit feedback": "Пошаљите повратну информацију",
    "Subscribe": "Претплатите се",
    "Subscribed": "Претплаћено",
    "Subscription plan updated successfully": "План претплате је успешно ажуриран",
    "Success": "Успешно",
    "Success! Check your email for magic link to sign-in.": "Успешно! Проверите Ваш email за магични линк за пријаву.",
    "Success! Your account is fully activated, you now have access to all content.": "Успешно! Ваш налог је потпуно активиран, сада имате приступ свим садржајима.",
    "Success! Your email is updated.": "Успешно! Ваш email је ажуриран.",
    "Successfully unsubscribed": "Успешно сте се одјавили",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Хвала Вам што сте се претплатили. Пре него што почнете са читањем, у наставку су неки други сајтови који би Вам могли бити занимљиви.",
    "Thank you for your support": "Хвала Вам на подршци",
    "Thank you for your support!": "Хвала Вам на подршци!",
    "Thanks for the feedback!": "Хвала на повратној информацији!",
    "That didn't go to plan": "То није ишло по плану",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Email адреса коју имамо за Вас је {memberEmail} — ако то није тачно, можете је ажурирати у <button>поставкама налога</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Дошло је до проблема при слању Ваше повратне информације. Молимо Вас покушајте касније.",
    "There was an error cancelling your subscription, please try again.": "Дошло је до грешке при отказивању Ваше претплате, покушајте поново.",
    "There was an error continuing your subscription, please try again.": "Дошло је до грешке при наставку Ваше претплате, покушајте поново.",
    "There was an error processing your payment. Please try again.": "Дошло је до грешке при обради Ваше уплате. Молимо Вас покушајте поново.",
    "There was an error sending the email, please try again": "Дошло је до грешке при слању email-а, покушајте поново.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Овај сајт је само на позив, контактирајте власника ради приступа.",
    "This site is not accepting donations at the moment.": "Овај сајт тренутно не прима донације.",
    "This site is not accepting payments at the moment.": "Овај сајт тренутно не прихвата уплате.",
    "This site only accepts paid members.": "Овај сајт прихвата само плаћене чланове.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Да бисте завршили регистрацију, кликните на линк за потврду у inbox-у. Ако не стигне у року од 3 минута, проверите фасциклу за нежељену пошту!",
    "To continue to stay up to date, subscribe to {publication} below.": "Да бисте остали у току, претплатите се на {publication} у наставку.",
    "Too many attempts try again in {number} days.": "Превише покушаја, покушајте поново за {number} дана.",
    "Too many attempts try again in {number} hours.": "Превише покушаја, покушајте поново за {number} сати.",
    "Too many attempts try again in {number} minutes.": "Превише покушаја, покушајте поново за {number} минута.",
    "Too many different sign-in attempts, try again in {number} days": "Превише различитих покушаја пријављивања, покушајте поново за {number} дана",
    "Too many different sign-in attempts, try again in {number} hours": "Превише различитих покушаја пријављивања, покушајте поново за {number} сати",
    "Too many different sign-in attempts, try again in {number} minutes": "Превише различитих покушаја пријављивања, покушајте поново за {number} минута",
    "Too many sign-up attempts, try again later": "Превише покушаја регистрације, покушајте поново касније",
    "Try free for {amount} days, then {originalPrice}.": "Пробајте бесплатно за {amount} дана, након тога {originalPrice}.",
    "Unable to initiate checkout session": "Није могуће покренути сесију плаћања",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Откључајте приступ свим билтенима тако што ћете постати плаћени претплатник.",
    "Unsubscribe from all emails": "Одјавите се са свих email-ова",
    "Unsubscribed": "Одјављени",
    "Unsubscribed from all emails.": "Одјављени са свих email-ова.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Одјављивање са email-ова неће отказати Вашу плаћену претплату на {title}",
    "Update": "Ажурирајте",
    "Update your preferences": "Ажурирајте своје преференце",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Линк за верификацију је послат, проверите Ваш inbox",
    "Verify your email address is correct": "Проверите да ли је Ваша email адреса исправна",
    "Verifying...": "Верификација...",
    "View plans": "Погледајте планове",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Нисмо могли да Вас одјавимо јер email адреса није пронађена. Молимо Вас да контактирате власника сајта.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Добро дошли назад, {name}!",
    "Welcome back!": "Добро дошли назад!",
    "Welcome to {siteTitle}": "Добро дошли на {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Када inbox не прихвата email, то се обично назива одбијање. У многим случајевима то може бити привремено. Међутим, у неким случајевима, одбијени email може бити враћен као трајни неуспех ако је email адреса невалидна или непостојећа.",
    "Why has my email been disabled?": "Зашто је мој email онемогућен?",
    "X (Twitter)": "",
    "year": "година",
    "Yearly": "Годишње",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Тренутно имате бесплатно чланство, надоградите на плаћену претплату за пуни приступ.",
    "You have been successfully resubscribed": "Успешно сте поново претплаћени",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Тренутно не примате email-ове",
    "You're not receiving emails": "Не примате email-ове",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Не примате email-ове јер сте или означили недавно примљену поруку као нежељену, или поруке нису могле бити испоручене на Вашу email адресу.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Успешно сте се пријавили.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Успешно сте се претплатили на <strong>{siteTitle}</strong>",
    "Your account": "Ваш налог",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Поновна претплата на Ваш email није успела, покушајте поново",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "Ваш inbox",
    "Your input helps shape what gets published.": "Ваше учешће помаже у обликовању онога што ће бити објављено.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Ваша претплата истиче {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ваша претплата ће бити обновљена {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Ваша претплата ће почети {subscriptionStart}"
}
